import EvaluationMethodDetailModel from "models/EvaluationMethod/evaluationMethodDetailModel";
import {
	IEvaluationMethod,
	IEvaluationMethodGridDetail,
} from "models/EvaluationMethod/evaluationMethodModel";
import { TableFilterModel } from "models/TableFilterModel";
import { BaseService } from "./base.service";

class EvaluationMethodServiceInternal extends BaseService {
	getEvaluationMethodList = async (
		model: TableFilterModel
	): Promise<IEvaluationMethodGridDetail[]> =>
		this.callApi<IEvaluationMethodGridDetail[]>(
			`EvaluationMethod/GetEvaluationMethodList`,
			"POST",
			undefined,
			model
		);

	saveEvaluationMethod = async (
		model: EvaluationMethodDetailModel
	): Promise<{ evaluationMethodId: number }> =>
		this.callApi<{ evaluationMethodId: number }>(
			`EvaluationMethod/Save`,
			"POST",
			undefined,
			model
		);

	updateEvaluationMethod = async (
		model: EvaluationMethodDetailModel
	): Promise<{ evaluationMethodId: number }> =>
		this.callApi<{ evaluationMethodId: number }>(
			`EvaluationMethod/Update/${model.evaluationMethodId}`,
			"PUT",
			undefined,
			model
		);

	deleteEvaluationMethod = async (
		evaluationMethodId: number
	): Promise<undefined> =>
		this.callApi<undefined>(
			`EvaluationMethod/Delete/${evaluationMethodId}`,
			"DELETE"
		);

	getLatestThresholdFromValue = async (): Promise<number> =>
		this.callApi<number>(`EvaluationMethod/GetLatestThresoldFromValue`, "GET");

	getEvaluationMethodDetail = async (
		evaluationMethodId: number
	): Promise<EvaluationMethodDetailModel> =>
		this.callApi<EvaluationMethodDetailModel>(
			`EvaluationMethod/GetById/${evaluationMethodId}`,
			"GET"
		);

	getAllEvaluationMethodList = async (): Promise<IEvaluationMethod[]> =>
		this.callApi<IEvaluationMethod[]>(`EvaluationMethod/GetAll`, "GET");

	checkEvaluationMethodAlreadyUsed = async (
		evaluationMethodId: number
	): Promise<{ isAlreadyUsed: boolean }> =>
		this.callApi<{ isAlreadyUsed: boolean }>(
			`EvaluationMethod/CheckEvaluationMethodAlreadyUsed/${evaluationMethodId}`,
			"GET"
		);

	getEvaluationMethodListByBidTypeAndAmount = async (
		bidId: number
	): Promise<EvaluationMethodDetailModel[]> =>
		this.callApi<EvaluationMethodDetailModel[]>(
			`EvaluationMethod/GetEvaluationMethodListByBidTypeAndAmount/${bidId}`,
			"GET"
		);
}

export const EvaluationMethodService = new EvaluationMethodServiceInternal();
